import { Send } from "lucide-react";
import { SectionHeader } from "@/components/ui/SectionHeader";

export const LiveResults = ({ stats = [], config }) => (
  <section id="results" className="gm-section" style={{ background: "var(--gm-navy-950)" }}>
    <div className="gm-container grid gap-10 lg:grid-cols-12 lg:gap-12">
      <div className="lg:col-span-6">
        <SectionHeader
          eyebrow="Community"
          title="Check it yourself before you decide"
          subtitle="We do not publish profit screenshots or testimonials on this page. Our Telegram channel is where updates, setting changes and whatever users post themselves live. Masuk dulu, baca sendiri."
          testId="results-header"
        />

        <a
          href={config?.telegram_channel || "#"}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="live-results-telegram-cta"
          aria-label="Open our Telegram channel in a new tab"
          className="gm-btn-red mt-7 inline-flex min-h-[48px] items-center gap-2 rounded-xl px-5 text-sm font-bold"
        >
          <Send className="h-4 w-4" />
          Open the Telegram channel
        </a>

        <p className="mt-6 text-xs leading-relaxed" style={{ color: "var(--gm-muted-2)" }}>
          Anything posted there comes from users, good days and bad days. Gold can swing
          hard, so read the risk warning at the bottom of this page before you run
          anything live.
        </p>
      </div>

      <div className="lg:col-span-6">
        <div
          className="rounded-xl"
          data-testid="stats-grid"
          style={{ background: "#0a1230", border: "1px solid rgba(255,255,255,0.1)" }}
        >
          <p
            className="px-5 py-4 text-xs font-semibold uppercase tracking-wider"
            style={{
              color: "var(--gm-muted-2)",
              borderBottom: "1px solid rgba(255,255,255,0.1)",
            }}
          >
            The facts
          </p>
          <dl>
            {stats.map((s) => (
              <div
                key={s.slug}
                data-testid={`stat-${s.slug}`}
                className="flex items-baseline justify-between gap-4 px-5 py-3.5"
                style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
              >
                <dt className="text-xs" style={{ color: "var(--gm-muted-2)" }}>
                  {s.label}
                </dt>
                <dd className="text-right text-sm font-bold text-white">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <p
          className="mt-3 text-[11px]"
          data-testid="stats-disclaimer"
          style={{ color: "var(--gm-muted-2)" }}
        >
          Product facts only. We do not display member counts or account numbers we
          cannot prove to you.
        </p>
      </div>
    </div>
  </section>
);
